import { createAction, handleActions } from 'redux-actions';
import { call, put, takeLatest, takeLeading, select } from 'redux-saga/effects';
import { requestGuideMap } from 'modules/fetch/api';

const GUIDE_MAP_GET = 'guideMap/GUIDE_MAP_GET';
const SET_LEVEL_1_LIST = 'guideMap/SET_LEVEL_1_LIST';

export const guideMapGetList = createAction(GUIDE_MAP_GET);
export const setLevel1List = createAction(SET_LEVEL_1_LIST);

const initialize = {
  guideMapList: [],
  level1List: [],
};

export function* getGuideMapList(action) {
  try {
    const result = yield call(requestGuideMap, action.payload);

    yield put({ type: GUIDE_MAP_GET, payload: result.data });
  } catch (err) {
    console.log(`consoleMessage:::${err.message}`);
  }
}

export function* getSetLevel1List() {
  try {
    const guideArr = yield select(state => state.guideMapGetList.guideMapList);
    const clickCategory = yield select(state => state.setCategory.category);
    const filterCategory = guideArr.filter(flowChartObj => flowChartObj.category === clickCategory);
    for (const index in filterCategory) {
      const currentIndex = parseInt(index, 10);
      const nextIndex = parseInt(index, 10) + 1;
      if (filterCategory[nextIndex] !== undefined) {
        if (filterCategory[currentIndex].level1 !== '0' && filterCategory[currentIndex].level2 === '0') {
          const currentElement = JSON.parse(JSON.stringify(filterCategory[currentIndex]));
          const nextElement = JSON.parse(JSON.stringify(filterCategory[nextIndex]));
          delete currentElement.sentence;
          delete currentElement.Intent;
          delete nextElement.sentence;
          delete nextElement.Intent;
          currentElement.level2 = '1';
          if (JSON.stringify(currentElement) === JSON.stringify(nextElement)) {
            filterCategory[currentIndex].isContinueNode = true;
          }
        } else if (filterCategory[currentIndex].level1 !== '0' && filterCategory[currentIndex].level2 !== '0' && filterCategory[currentIndex].level3 === '0') {
          const currentElement = JSON.parse(JSON.stringify(filterCategory[currentIndex]));
          const nextElement = JSON.parse(JSON.stringify(filterCategory[nextIndex]));
          delete currentElement.sentence;
          delete currentElement.Intent;
          delete nextElement.sentence;
          delete nextElement.Intent;
          currentElement.level3 = 'a';
          if (JSON.stringify(currentElement) === JSON.stringify(nextElement)) {
            filterCategory[currentIndex].isContinueNode = true;
          }
        } else if (
          filterCategory[currentIndex].level1 !== '0' &&
          filterCategory[currentIndex].level2 !== '0' &&
          filterCategory[currentIndex].level3 !== '0' &&
          filterCategory[currentIndex].level4 === '0'
        ) {
          const currentElement = JSON.parse(JSON.stringify(filterCategory[currentIndex]));
          const nextElement = JSON.parse(JSON.stringify(filterCategory[nextIndex]));
          delete currentElement.sentence;
          delete currentElement.Intent;
          delete nextElement.sentence;
          delete nextElement.Intent;
          currentElement.level4 = '가';
          if (JSON.stringify(currentElement) === JSON.stringify(nextElement)) {
            filterCategory[currentIndex].isContinueNode = true;
          }
        } else if (
          filterCategory[currentIndex].level1 !== '0' &&
          filterCategory[currentIndex].level2 !== '0' &&
          filterCategory[currentIndex].level3 !== '0' &&
          filterCategory[currentIndex].level4 !== '0' &&
          filterCategory[currentIndex].level5 === '0'
        ) {
          const currentElement = JSON.parse(JSON.stringify(filterCategory[currentIndex]));
          const nextElement = JSON.parse(JSON.stringify(filterCategory[nextIndex]));
          delete currentElement.sentence;
          delete currentElement.Intent;
          delete nextElement.sentence;
          delete nextElement.Intent;
          currentElement.level5 = 'A';
          if (JSON.stringify(currentElement) === JSON.stringify(nextElement)) {
            filterCategory[currentIndex].isContinueNode = true;
          }
        } else if(filterCategory[currentIndex].level5 !== '0') {
            filterCategory[currentIndex].isContinueNode = false;
          }
      }
      if (filterCategory[currentIndex].isContinueNode === undefined) {
        filterCategory[currentIndex].isContinueNode = false;
      }
    }
    
    yield put({ type: SET_LEVEL_1_LIST, payload: filterCategory });
  } catch (err) {
    console.log(`consoleMessage:::${err.message}`);
  }
}

export function* guideMapSaga() {
  yield takeLeading(GUIDE_MAP_GET, getGuideMapList);
}

export function* setLevel1Saga() {
  yield takeLeading(SET_LEVEL_1_LIST, getSetLevel1List);
}

export default handleActions(
  {
    [GUIDE_MAP_GET]: (state, { payload: guideMapList }) => {
      return { ...state, guideMapList };
    },

    [SET_LEVEL_1_LIST]: (state, { payload: level1List }) => {
      return { ...state, level1List };
    },
  },
  initialize
);
